// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"

export default class extends Controller {
  static values = { expanded: Boolean }
  static targets = [ "icon", "submenu" ]
  static classes = [ "expanded", "collapsed" ]

  connect() {
    console.log("Connected")
    console.log(this.expandedClass)
    this.submenuTargets.forEach(submenu => submenu.hidden = !this.expandedValue)

  }

  expandedValueChanged() {
    this.rotateIcon()
    this.toggleSubmenu()
  }

  rotateIcon() {
    if (this.expandedValue) {
      this.iconTarget.classList.remove(this.collapsedClass)
      this.iconTarget.classList.add(...this.expandedClass.split(" "))
    } else {
      this.iconTarget.classList.remove(...this.expandedClass.split(" "))
      this.iconTarget.classList.add(this.collapsedClass)
    }
  }

  toggleSubmenu() {
    this.submenuTargets.forEach(submenu => submenu.hidden = !this.expandedValue)
  }

  toggle(event) {
    event.preventDefault()

    this.expandedValue = !this.expandedValue

    // if (this.expandedValue) {
    //   console.log("toggle")
    //   this.iconTarget.classList.remove(...this.expandedClass.split(" "))
    //   this.iconTarget.classList.add(this.collapsedClass)
    //   this.expandedValue = false      
    // } else {
    //   console.log("toggle")
    //   this.iconTarget.classList.remove(this.collapsedClass)
    //   this.iconTarget.classList.add(...this.expandedClass.split(" "))
    //   this.expandedValue = true
    // }
    // this.submenuTargets.forEach(submenu => submenu.hidden = !this.expandedValue)
  }
}
